// src/App.jsx
import React, { useRef } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage.jsx';
import ProjectsPage from './pages/Projects.jsx';
import SkillsetPage from './pages/SkillsetPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import Cursor from './components/Cursor.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';

function App() {
  const mainContentRef = useRef(null);

  return (
    <Router>
      <Cursor />
      <Navbar />
      <ScrollToTop containerRef={mainContentRef} />

      <div ref={mainContentRef} style={{ overflowY: 'auto', height: '100vh' }}>
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/skillset" element={<SkillsetPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
